import { createSlice } from "@reduxjs/toolkit";
import { GameListsRecommendThunk, GameListsThunk } from "./gameThunk";
import GameBrands from "../../../components/images/GameBrands";
import APP from "../../../common/app";



const gameSlice = createSlice({
  name: `game`,
  initialState: {
    providers: {
      slot: [
        {
          name: `PG Slot`,
          provider: `PGSOFT`,
          // image: GameBrands.pg 
          image: `/assets/images/games/slots/pgs.gif`,
        },
        {
          name: `Live22`,
          provider: `LIVE22`,
          // image: GameBrands.live22,
          image: `/assets/images/games/slots/live22.gif`,

        },
        {
          name: `Slot XO`,
          provider: `SLOTXO`,
          // image: GameBrands.slotxo,
          image: `/assets/images/games/slots/slotxo.gif`,

        },
        {
          name: `JILI`,
          provider: `JILI`,
          // image: `/assets/images/games/slots/jili.png`,
          image: `/assets/images/games/slots/jili.gif`,
        },
        {
          name: `918KISS`,
          provider: `918KISS`,
          // image: `/assets/images/games/slots/918.png`,
          image: `/assets/images/games/slots/kiss918.gif`,
        },
        {
          name: `Pragmatic`,
          provider: `PRAGMATIC_SLOT`,
          // image: `/assets/images/games/slots/pragmatic.png`,
          image: `/assets/images/games/slots/pmts.gif`,
        },

        {
          name: `micro`,
          provider: `MICRO`,
          //image: `/assets/images/games/slots/micro.png`,
          image: `/assets/images/games/slots/mgs.gif`,
        },
        {
          name: `Netent`,
          provider: `NETENT2`,
          //image: `/assets/images/games/slots/netent.png`,
          image: `/assets/images/games/slots/nete.gif`,
        },
        {
          name: `Royal GClub`,
          provider: `ROYALGCLUB`,
          // image: `/assets/images/games/casino/royalgclub.png`,
          image: `/assets/images/games/casino/RG.gif`,
        },
      ],
      slotnew: [
        {
          name: `royal`,
          provider: `RSG`,
          image: `/assets/images/games/slots/royal.png`,
        },
        {
          name: `ACE333`,
          image: `/assets/images/games/slots/ace333.png`,
        },
        {
          name: `AMBSLOT`,
          image: `/assets/images/games/slots/ambslot.png`,
        },
        {
          name: `AMEBA`,
          image: `/assets/images/games/slots/ameba.png`,
        },
        {
          name: `ASKMEBET`,
          image: `/assets/images/games/slots/askmebet.png`,
        },
        {
          name: `CQ9 GAMING`,
          image: `/assets/images/games/slots/cq9-gaming.png`,
        },
        {
          name: `CREATIVE GAMING`,
          image: `/assets/images/games/slots/creativegaming.png`,
        },
        {
          name: `DRAGON GAMING`,
          image: `/assets/images/games/slots/dragon-gaming.png`,
        },
        {
          name: `EVO PLAY`,
          image: `/assets/images/games/slots/evo-play.png`,
        },
        {
          name: `FUNKY GAME`,
          image: `/assets/images/games/slots/funky-game.png`,
        },
        {
          name: `HABANERO GAME`,
          image: `/assets/images/games/slots/habanero.png`,
        },
        {
          name: `I8`,
          image: `/assets/images/games/slots/i8.png`,
        },
        {
          name: `JOKER`,
          image: `/assets/images/games/slots/joker-123.png`,
        },
        {
          name: `MANNA PLAY`,
          image: `/assets/images/games/slots/manna-play.png`,
        },
        {
          name: `RAJA PLAY`,
          image: `/assets/images/games/slots/raja-slot.png`,
        },
        {
          name: `RED TIGER`,
          image: `/assets/images/games/slots/red-tiger.png`,
        },
        {
          name: `REKAX GAMING`,
          image: `/assets/images/games/slots/relax-gaming.png`,
        },
        {
          name: `SAMPLE PLAY`,
          image: `/assets/images/games/slots/sample-play.png`,
        },
        {
          name: `SLOT NINJA`,
          image: `/assets/images/games/slots/slot-ninja.png`,
        },
        {
          name: `SPADE GAMING`,
          image: `/assets/images/games/slots/spade-gaming.png`,
        },
        {
          name: `SPINIX`,
          image: `/assets/images/games/slots/spinix.png`,
        },
        {
          name: `UPG SLOT`,
          image: `/assets/images/games/slots/upg-slot.png`,
        },
        {
          name: `YGGDRASIL GAMING`,
          image: `/assets/images/games/slots/yggdrasil.png`,
        },
      ],
      casino: [
        {
          name: `Sexy Gaming`,
          provider: `SEXY`,
          // image: GameBrands.sexy,
          image: `/assets/images/games/casino/sex.gif`,
        },
        {
          name: `Pretty Gaming`,
          provider: `PRETTY`,
          // image: GameBrands.pretty,
          image: `/assets/images/games/casino/pertygame.gif`,
        },
        {
          name: `Dream Gaming`,
          provider: `DREAM`,
          // image: GameBrands.dream
          image: `/assets/images/games/casino/dgm.gif`,
        },
        {
          name: `Sa Gaming`,
          provider: `SAGAME`,
          // image: GameBrands.sa,
          image: `/assets/images/games/casino/sag.gif`,
        },
        {
          name: `Asia Gaming`,
          provider: `AGGAME`,
          // image: `/assets/images/games/casino/asia.png`,
          // name: `xxx`, image: GameBrands.soon
          image: `/assets/images/games/casino/ag.gif`,

        },
        {
          name: `Kingmaker`,
          provider: `KINGMAKER2`,
          // image: `/assets/images/games/casino/king.png`,
          image: `/assets/images/games/casino/kmk.gif`,

        },
        {
          name: `pragmatic`,
          provider: `PRAGMATIC_LIVECASINO`,
          // image: `/assets/images/games/casino/pragmatic-play.png`,
          image: `/assets/images/games/casino/palamatic.gif`,

        },
      ],
      casinonew: [
        {
          name: `Royal GClub`,
          provider: `ROYALGCLUB`,
          // image: `/assets/images/games/casino/royalgclub.png`,
          image: `/assets/images/games/casino/RG.gif`,
        },
        {
          name: `ALL BET`,
          // image: `/assets/images/games/casino/all-bet.png`,
          image: `/assets/images/games/casino/allbet.gif`,

        },
        {
          name: `BET GAMES TV`,
          // image: `/assets/images/games/casino/bet-games-tv.png`,
          image: `/assets/images/games/casino/Bet-tv.gif`,

        },
        {
          name: `BIG GAMING`,
          // image: `/assets/images/games/casino/big-gaming.png`,
          image: `/assets/images/games/casino/BG-Game.gif`,

        },
        {
          name: `EBET`,
          // image: `/assets/images/games/casino/ebet.png`,
          image: `/assets/images/games/casino/ebet.gif`,

        },
        {
          name: `WM CASINO`,
          // image: `/assets/images/games/casino/wm-casino.png`,
          image: `/assets/images/games/casino/wm.gif`,

        },
      ],
      lotto: [
        {
          name: `RMT LOTTO`,
          directLogin: `/lotto/login`,
          image: `/assets/images/games/lotto/rtm.png`,
          // name: `xxx`, image: GameBrands.soon
        },
        {
          name: `SIAM LOTTO`,
          directLogin: `/siamlot/login`,
          image: `/assets/images/games/lotto/siamlot.png`,
          // name: `xxx`, image: GameBrands.soon
        },
      ],
      lottonew: [
        {
          name: `SIAM LOTTO`,
          directLogin: `/siamlot/login`,
          image: `/assets/images/games/lotto/rtm.png`,
          // name: `xxx`, image: GameBrands.soon
        },
        {
          name: `Yeegee`,
          image: `/assets/images/games/lotto/yeegee.png`,
        },
        {
          name: `Hotgraph`,
          image: `/assets/images/games/lotto/hotgraph.png`,
        },
        {
          name: `Lao`,
          image: `/assets/images/games/lotto/lao.png`,
        },
        {
          name: `Hanuay`,
          image: `/assets/images/games/lotto/hanuay.png`,
        },
        {
          name: `Korean`,
          image: `/assets/images/games/lotto/korean.png`,
        },
      ],
      sport: [
        {
          name: `UFA Bet`,
          image: `/assets/images/games/sport/ufa.png`,
          directLogin: `/ufabet/login`,
        },
      ],
      sportnew: [
        {
          name: `Sbobet`,
          image: `/assets/images/games/sport/sbobet.png`,
        },
        {
          name: `sba`,
          image: `/assets/images/games/sport/sba.png`,
        },
        {
          name: `Cockfight`,
          provider: `COCKFIGHT`,
          image: `/assets/images/games/sport/crockfigt.png`,
        },
        {
          name: `Muay Thai`,
          image: `/assets/images/games/sport/muay.png`,
        },
        {
          name: `Crow`,
          image: `/assets/images/games/sport/crow.png`,
        },
      ],
    },
    games: null,
    openGame: null,
    gamesRecommend: [],
    gamesRecommend2: [],
  },
  reducers: {
    ResetGame: (state, { payload }) => {
      return { ...state, games: null };
    },
    SetOpenGame: (state, { payload }) => {
      return { ...state, openGame: payload };
    },
    ResetGameRec: (state, { payload }) => {
      return { ...state, gamesRecommend: [] };
    },
    ResetGameRec2: (state, { payload }) => {
      return { ...state, gamesRecommend2: [] };
    },
    RemovePGSlot: (state, { payload }) => {
      if (!APP.pgslot) {
        const updatedSlotProviders = state.providers.slot.filter(provider => provider.provider !== 'PGSOFT');
        return {
          ...state,
          providers: {
            ...state.providers,
            slot: updatedSlotProviders,
          },
        };
      } else {
        return state;
      }
    },
  },
  extraReducers: {
    [GameListsThunk.fulfilled]: (state, { payload }) => {
      return { ...state, games: payload };
    },
    [GameListsRecommendThunk.fulfilled]: (state, { payload }) => {
      return {
        ...state,
        gamesRecommend: [...state.gamesRecommend, ...payload.games],
        gamesRecommend2: [...state.gamesRecommend2, ...payload.games],
      };
    },
  },
});



export const getGames = (state) => state.game.games;
export const getGamesRec = (state) => state.game.gamesRecommend;
export const getGamesRec2 = (state) => state.game.gamesRecommend2;
export const getOpenGame = (state) => state.game.openGame;
export const getGameProviders = (state) => state.game.providers;

export const { ResetGame, ResetGameRec, SetOpenGame, RemovePGSlot, ResetGameRec2 } = gameSlice.actions;
export default gameSlice.reducer;
